import { IColumnSection } from "@faire/web-api--source/indigofair/data/IColumnSection";
import { IComponent } from "@faire/web-api--source/indigofair/data/IComponent";
import { IConductorComponent } from "@faire/web-api--source/indigofair/data/IConductorComponent";
import { IConductorSDUIComponent } from "@faire/web-api--source/indigofair/data/IConductorSDUIComponent";
import { ISection } from "@faire/web-api--source/indigofair/data/ISection";
import { IViewLayout } from "@faire/web-api--source/indigofair/data/IViewLayout";

/**
 * Merges multiple conductor components into a single view layout.
 * Each component's content is merged into a single view layout with multiple content items.
 */
export const mergeConductorComponents = (
  components: IConductorComponent[] | undefined
): IConductorComponent | undefined => {
  if (!components?.length) {
    return undefined;
  }

  // Use the first component's view layout as the base
  const conductorComponent = components[0];
  if (!conductorComponent) {
    return undefined;
  }

  // Collect all content items from all components
  const mergedContent: IComponent[] = [];

  components.forEach((component) => {
    const viewLayout = component?.sdui_component?.view_layout;
    mergedContent.push(
      ...(viewLayout?.content?.[0]?.column_section?.components ?? [])
    );
  });

  // Create merged view layout
  return IConductorComponent.build({
    ...conductorComponent,
    sdui_component: IConductorSDUIComponent.build({
      ...conductorComponent.sdui_component,
      view_layout: IViewLayout.build({
        ...conductorComponent.sdui_component?.view_layout,
        content: [
          ISection.build({
            ...conductorComponent.sdui_component?.view_layout?.content[0],
            column_section: IColumnSection.build({
              components: mergedContent,
            }),
          }),
        ],
      }),
    }),
  });
};
